export default __webpack_public_path__ + "locales/hy-AM/InviteDialog.json?hash=5f70789c7b1244485d3c876fbef92272";